import { ReactElement } from 'react'

import { updateCampaigns } from 'api/Cerebro/orgScoped/amazonAdsApi'
import { useResource } from 'components/EditableFields/localHooks'
import { userHasManageLabelsPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions, useResourceOfPage } from 'hooks'
import { CampaignGroupBy, Label } from 'types'

import { DeleteField } from '../../SharedFields/DeleteField'

interface Props<RecordType> {
    dataIndex: string[]
    readOnly: boolean
    record: RecordType
    reloadData: () => void
}

function RemoveFromLabelField<RecordType extends CampaignGroupBy>({
    dataIndex = ['campaign'],
    readOnly = false,
    record,
    reloadData,
}: Props<RecordType>): ReactElement {
    const hasLabelPermissions = useUserHasPermissions(
        userHasManageLabelsPermissions
    )

    const label: Label | null = useResourceOfPage('labelPage')

    const { getFromResource, resourceId } = useResource<RecordType>(
        record,
        dataIndex,
        'campaign'
    )

    const getIsDisabled = (): boolean => {
        const userCanManageCampaign = getFromResource(['user_can_manage'], true)
        return !hasLabelPermissions || !userCanManageCampaign || readOnly
    }

    return (
        <DeleteField
            disabled={getIsDisabled()}
            okText="Remove"
            title={`Are you sure you want to remove this campaign from ${label?.name}?`}
            updateRequestApi={updateCampaigns}
            updateRequestCallback={reloadData}
            updateRequestData={{
                items: [{ id: resourceId, remove_label_ids: [label?.id] }],
            }}
            updateRequestSuccessMesg="Campaign successfully removed"
        />
    )
}

export default RemoveFromLabelField
